export default __webpack_public_path__ + "static/media/Mädchen-mit-Meerschweinchen.61f858c2.png";